export default {
  "content": "<path d=\"M29 17.15c.56 0 1-.44 1-1s-.42-1.06-1.02-1h-26c-.54 0-.98.46-.98 1s.44 1 1 1h26z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "33",
    "fill": "currentColor",
    "viewBox": "0 0 32 33"
  }
};